<template>
    <div class="d-flex flex-wrap">

        <!-- VALID COLLECT EMAIL AND CELL -->
        <div style="width: 300px">
            <v-select
                v-bind:items="countries"
                v-model="selectedCountryCode"
                label="Country code"
                item-text="name"
                item-value="value"
                no-data-text="No countries found"
                prepend-icon="mdi-phone"
                :error-messages="errorMessagesCountryCode"
                :rules="[v => !!v || 'Country code is required!']"
                v-on:input="selectedEvent"
            >
            </v-select>
        </div>

        <div class="flex-grow-1">
            <v-text-field
                label="Mobile phone number"
                class="ml-4"
                v-model="enteredPhoneNumber"
                :rules="cellValidationRules"
                required
                :error-messages="errorMessagesPhoneNumber"
                @keyup="matchCell"
                v-on:input="inputEvent"
            ></v-text-field>
        </div>

    </div>
</template>

<script>
export default {

    props: ['countryCode', 'phoneNumber', 'errorMessagesCountryCode', 'errorMessagesPhoneNumber'],

    components: {},

    watch: {
        countryCode(newValue) {
            this.selectedCountryCode = newValue;
        },
        phoneNumber(newValue) {
            this.enteredPhoneNumber = newValue;
        }
    },

    data() {
        return {
            selectedCountryCode: null,
            countries: [
                {name: 'United States', value: '+1'},
                {name: 'United Kingdom', value: '+44'},
                {name: 'Canada', value: '+1'},
                {name: 'Austria', value: '+43'},
                {name: 'Australia', value: '+61'},
                {name: 'Albania', value: '+355'},
                {name: 'Belgium', value: '+32'},
                {name: 'Bulgaria', value: '+359'},
                {name: 'China', value: '+86'},
                {name: 'Croatia', value: '+385'},
                {name: 'Cyprus', value: '+357'},
                {name: 'Czech Republic', value: '+420'},
                {name: 'Denmark', value: '+45'},
                {name: 'Estonia', value: '+372'},
                {name: 'Finland', value: '+358'},
                {name: 'France', value: '+33'},
                {name: 'Gibraltar', value: '+350'},
                {name: 'Germany', value: '+49'},
                {name: 'Greece', value: '+30'},
                {name: 'Hong Kong', value: '+852'},
                {name: 'Hungary', value: '+36'},
                {name: 'Iceland', value: '+354'},
                {name: 'India', value: '+91'},
                {name: 'Ireland', value: '+353'},
                {name: 'Israel', value: '+972'},
                {name: 'Italy', value: '+39'},
                {name: 'Japan', value: '+81'},
                {name: 'Latvia', value: '+371'},
                {name: 'Liechtenstein', value: '+423'},
                {name: 'Lithuania', value: '+370'},
                {name: 'Luxembourg', value: '+352'},
                {name: 'Malaysia', value: '+60'},
                {name: 'Malta', value: '+356'},
                {name: 'Monaco', value: '+377'},
                {name: 'Netherlands', value: '+31'},
                {name: 'New Zealand', value: '+64'},
                {name: 'Norway', value: '+47'},
                {name: 'Philippines', value: '+63'},
                {name: 'Poland', value: '+48'},
                {name: 'Portugal', value: '+351'},
                {name: 'Romania', value: '+40'},
                {name: 'Russia', value: '+7'},
                {name: 'Serbia', value: '+381'},
                {name: 'Slovakia', value: '+421'},
                {name: 'Slovenia', value: '+386'},
                {name: 'Spain', value: '+34'},
                {name: 'South Korea', value: '+82'},
                {name: 'Sweden', value: '+46'},
                {name: 'Switzerland', value: '+41'},
                {name: 'Taiwan', value: '+886'},
                {name: 'Thailand', value: '+66'},
                {name: 'Turkey', value: '+90'},
                {name: 'Ukraine', value: '+380'},
                {name: 'United Arab Emirates', value: '+971'},
                {name: 'Vietnam', value: '+84'},
            ],
            cellValidationRules: [
                (v) => this.matchCell(v) || 'Valid cellular number consists of numbers and dashes (-)'
            ],
            enteredPhoneNumber: '',
        }
    },

    created() {

        // Postfix country code to country name for better clarity for users
        this.countries.forEach(function (country, index, theArray) {
            theArray[index].name = theArray[index].name + ' (' + theArray[index].value + ')';
        });
    },

    methods: {

        // Cellular number matching
        matchCell(v) {
            var match = new RegExp('^([0-9]{1,})([-\\s])?([0-9]{1,})([-\\s])?([0-9]{1,})', "g");

            if (match.test(v)) {
                return true;
            } else {
                return false;
            }
        },

        inputEvent(e) {
            this.$emit('phone-number-input', e);
        },

        selectedEvent(e) {
            this.$emit('country-code-selected', e);
        }
    }
}
</script>
